export const componentConfig = {
    210: 'live'
};
